import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { IPaymentMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { IMandatoryField } from '@wix/cashier-core/dist/src/services/MandatoryFields/types';
import { PaymentFailResult } from '../../sdk/types/PaymentCompleteResult';
import { Expiration } from '../../types/Expiration';

export interface IClientPaymentMethod {
  value: string;
  label: string;
  icon?: string;
  additionalInfo?: any;
  connectedProviderId?: PaymentProvider;
  mandatoryFields?: IMandatoryField[];
  disabled: boolean;
  frameable: boolean;
  responsive: boolean;
  redirectable: boolean;
  serverPMethod: IPaymentMethod;
}

export interface PaymentError {
  type: 'PAYMENT_ERROR';
  error: PaymentFailResult;
}

export interface ActivePaymentMethod extends IPaymentMethod {
  name: string;
  selectedOption: SelectedOption;
  iconUrl: any;
  additionalInfo?: {
    installments?: IPaymentMethod['installments'];
    [key: string]: any;
  };
}

export const enum OptionType {
  SAVED_CREDIT_CARD = 'savedCreditCard',
  PAYMENT_METHOD = 'paymentMethod',
}

export const enum WidgetJob {
  LocalizationLoad,
  ExperimentsLoad,
  CashierSDKInit,
  SettingsLoad,
  MethodScreenLoad,
  SaveCCInit,
}

export type SelectedOption = {
  type: OptionType;
  value: PaymentMethod;
  payload?: {
    creditCardId: string;
    cardDetails: {
      additionalInformation?: any;
      billingAddress?: any;
      network?: CreditCardNetwork;
      expired?: boolean;
      expiration?: Expiration;
    };
  };
};
